import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {  faChartPie } from '@fortawesome/pro-solid-svg-icons'
import { Dispatch } from './architecture/frontend/index'
import _ from 'lodash'
import loadingSVG from '../media/loading.svg'

const DashboardBox = (props) => {
  const title = props._title
  const count = props._count
  const onClick = props.onClick
  return (
    <div className='pl3 flex flex-column items-end justify-between' style={{width: 90, height: 110}}>
      <div></div>
      <div className='w-100 f6 fw7 tc'>{title}</div>
      <div className='w-100 h3 br4 fw7 f4 bg-evonik-purple white flex justify-center items-center pointer hover-bg-evonik-light-purple'
        onClick={onClick}
      >{count}</div>
    </div>
  )
}

const Dashboard = (props) => {
  return (
    <div className='w-100 ph3'>
      <div className='w-100 pa2 ph3 flex items-center justify-between bg-evonik-purple' style={{position: 'sticky', top:0}}>
        <div className='flex items-center'>
          {/* <FontAwesomeIcon className='f6 white' icon={faChartPie} /> */}
          <div className='pl2 pa2 fw7 f6 white'>Dashboard </div>
        </div>
      </div>
      <div className='w-100 pl3 pt3 pt4 f6 fw5 tc'>Welcome to Evonik's Claim Manager</div> <br/><br/>
      { props.sidebar ?
      <>
        <div className='mt1 pt4 w-100 fw7 f4 flex evonik-purple items-center justify-center bg-light-gray'><FontAwesomeIcon className='pr3 f4' icon={faChartPie} /> Claim Management Workflow</div>
        <div className='pb5 pt5 w-100 flex items-center justify-center bg-light-gray'>
          <div className='pr4'>
            <div className='pl3 flex flex-column items-end justify-between' style={{width: 90, height: 80}}>
              <div></div>
              <div className='w-100 h3 br4 fw4 f5 bg-evonik-purple white flex justify-center items-center tc pointer hover-bg-evonik-light-purple'
                onClick={e => Dispatch.nextAction('view', {type: 'newClaim'})}
                >New Claim</div>
            </div>
            <div className='pl3 flex flex-column items-end justify-between' style={{width: 90, height: 80}}>
              <div></div>
              <div className='w-100 h3 br4 fw4 f5 bg-evonik-purple white flex justify-center items-center tc pointer hover-bg-evonik-light-purple'
                onClick={e => Dispatch.nextAction('view', {type: 'importClaim'})}
                >Import Claims</div>
            </div>
          </div>
          <DashboardBox 
            _title='Incomplete' 
            _count={_.find(props.sidebar, sidebar => sidebar.view === 'claimNeedingShipment')?.count} 
            onClick={e => Dispatch.nextAction('view', {type: 'claimNeedingShipment'})} 
            {...props}
            />
          <div className='pl2 relative fw8 f4 moon-gray' style={{top: 20}}> > </div>
          <DashboardBox _title='Send To Referee' _count={_.find(props.sidebar, sidebar => sidebar.view === 'claimSendToReferee')?.count} 
            onClick={e => Dispatch.nextAction('view', {type: 'claimSendToReferee'})} 
            {...props}/>
          <div className='pl2 relative fw8 f4 moon-gray' style={{top: 20}}> > </div>
          <DashboardBox _title='Awaiting Referee' _count={_.find(props.sidebar, sidebar => sidebar.view === 'claimsAwaitingReferee')?.count} 
            onClick={e => Dispatch.nextAction('view', {type: 'claimsAwaitingReferee'})} 
            {...props}
            />
          <div className='pl2 relative fw8 f4 moon-gray' style={{top: 20}}> > </div>
          <DashboardBox _title='Requiring Payment' _count={_.find(props.sidebar, sidebar => sidebar.view === 'claimsRequiringPayment')?.count } 
            onClick={e => Dispatch.nextAction('view', {type: 'claimsRequiringPayment'})} 
          {...props}/>
        </div>
      </>
      :
      <div className='pt5 w-100 flex justify-center'>
        <div className='mh3 ' style={{width:60, height: 60}}>
          <img className='w-100 h-100' src={loadingSVG} alt='loading'/>
        </div>
      </div>
    }
    </div>
  )
}

export default Dashboard